import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: 'Delegation',
  description:
    'You can delegate your proposal/voting power to another Ethereum address without the SSAP/stkSSAP tokens leaving your wallet.',

  asset: 'Asset',
  selectAssetToDelegate: 'Select asset',

  type: 'Type',
  selectDelegationType: 'Select type',
  delegationVotes: 'Voting power',
  delegationProposalPower: 'Proposition power',

  delegationToAddress: 'Delegation to address',
  enterETHAddress: 'Enter ETH address',
  toAddressError: 'Please enter a valid address',

  buttonTitle: 'Delegate',
});
